import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  IonButton,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonCheckbox,
} from '@ionic/react';
import { Typeahead } from 'react-bootstrap-typeahead';
import _ from 'lodash';

import {
  resetUtilities,
  showLoading
} from '../../redux/actions';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware';
import store from '../../redux/store';
import { Col, Container, FormGroup } from 'reactstrap';
import CustomLabel from '../../components/CustomLabel';
import CustomInput from '../../components/CustomInput';
import CustomPropertySelect from '../../components/CustomPropertySelect';

const mapStateToProps = state => {
  return {
    properties: state.properties,
    units: state.units
  };
}

const mapDispatchToProps = {
  resetUtilities,
  showLoading
};

const ResetUtilitiesForm = (props) => {
  const [propertyId, setPropertyId] = useState("");
  const [properties, setProperties] = useState([]);
  const [units, setUnits] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [utilItem, setUtilItem] = useState("");
  const [error, setError] = useState({});
  const [UtilityItems] = useState(["water", "electricity"]);
  const [selectAllUnits, setSelectAllUnits] = useState(false);

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    setProperties(Object.values(props.properties));
    if (Object.values(props.properties).length === 1) {
      const singlePropertyId = Object.values(props.properties)[0].propertyId;
      setPropertyId(singlePropertyId);
      setUnitOptionsForProperty(singlePropertyId);
    }
  }, [props.properties]);

  const fetchInitialData = async () => {
    if (_.isEmpty(props.properties)) {
      await props.showLoading(true);
      await store.dispatch(fetchPropertiesUnitsTenants);
    }
  };

  const setUnitOptionsForProperty = (propertyId) => {
    const units = props.properties[propertyId]?.units || {};
    const options = Object.keys(units).map((unitId) => ({
      id: unitId,
      label: props.units[unitId]?.unitName || "Unknown Unit"
    }));
    setUnitOptions(options);
  };

  const handleSelectProperty = (event) => {
    const selectedPropertyId = event.target.value;
    setPropertyId(selectedPropertyId);
    setUnits([]);
    setUnitOptionsForProperty(selectedPropertyId);
    setSelectAllUnits(false);
  };

  const handleUnitChange = (selected) => {
    setUnits(selected);
    if(selected.length === unitOptions.length) {
      setSelectAllUnits(true);
    } else {
        setSelectAllUnits(false);
    }
  };

  const handleSelectAllUnits = (checked) => {
    let units = checked ? unitOptions : [];
    setUnits(units);
    setSelectAllUnits(checked);
    };

  const handleUtilityItemChange = (event) => {
    setUtilItem(event.target.value);
  };

  const validateFields = () => {
    const errors = {};
    if (!propertyId) errors.propertyId = "Property is required";
    if (units.length === 0) errors.units = "Select at least one unit";
    if (!utilItem) errors.utilItem = "Utility item is required";
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      const unitNames = units.map(unit => unit.label).join(", ");
      const confirmed = window.confirm(`Are you sure you want to reset ${utilItem} utilities for the selected unit(s) ${unitNames}?`);

      if (confirmed) {
        await props.showLoading(true);
        const resetUtilitiesPayload = {
          unitIds: units.map(unit => unit.id),
          utilityItem: utilItem
        };
        await props.resetUtilities(resetUtilitiesPayload);
      }
    }
  };

  return (
    <Container>
        <Col md={12} className='ml-5'>

            {/* Select Property */}
            <FormGroup row>
                <CustomLabel sm={12} md={4} for="propertyId">
                    Select Property
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} md={7} sm={12}>
                    <CustomInput
                        type="select"
                        id="propertyId"
                        className="mr-2"
                        name="propertyId"
                        value={propertyId}
                        onChange={handleSelectProperty}
                    >
                        <CustomPropertySelect propertiesArray={properties}/>
                    </CustomInput>
                </Col>
            </FormGroup>

            {/* Select Units */}
            <FormGroup row>
                <CustomLabel sm={12} md={4} for="units">
                    Select Unit(s).
                </CustomLabel>
                <Col style={{maxWidth: '450px'}} md={7} sm={12}>
                    <Typeahead
                    id="units"
                    clearButton
                    options={unitOptions}
                    selected={units}
                    multiple={true}
                    onChange={handleUnitChange}
                    placeholder="Select Units"
                    />
                </Col>
                {error.units && <p className="error-text">{error.units}</p>}
                {/* select all units checkbox */}
                {propertyId !== "" && (
                    <FormGroup row className='mt-2 ml-1'>
                    <CustomLabel sm={12} md={4} for="selectAll">
                    </CustomLabel>
                    <Col style={{maxWidth: '450px'}} md={7} sm={12}>
                        <IonCheckbox
                            slot="end"
                            checked={selectAllUnits}
                            className='mr-2'
                            onIonChange={e => handleSelectAllUnits(e.detail.checked)}
                        />
                        <IonLabel><small>Select All Units</small></IonLabel>
                    </Col>
                    </FormGroup>
                )}
            </FormGroup>

          {/* Select Utility Type */}
          <FormGroup row>
            <CustomLabel sm={12} md={4} for="utilityType">
                Select Utility.
            </CustomLabel>
            <Col style={{maxWidth: '450px'}} md={7} sm={12}>
                <IonSelect
                    interface="popover"
                    value={utilItem}
                    placeholder="Select Utility Item"
                    onIonChange={handleUtilityItemChange}
                >
                {UtilityItems.map((item) => (
                    <IonSelectOption key={item} value={item}>
                    {item}
                    </IonSelectOption>
                ))}
                </IonSelect>
            </Col>
          </FormGroup>
          {error.utilItem && <p className="error-text">{error.utilItem}</p>}

          {/* Reset Utilities Button */}
          <FormGroup row style={{ display: "flex", justifyContent: "center" }}>
              <IonButton
                style={{ width: "80%" }}
                onClick={handleSubmit}
                disabled={!propertyId || units.length === 0 || !utilItem}
              >
                Reset Utilities
              </IonButton>
          </FormGroup>

        </Col>

        </Container>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetUtilitiesForm);
